import React from "react";
import "./ReadonlySimplePaymentField.scss";
const ReadonlySimplePaymentField = ({ data, formData }: any) => {
  return <div className="readonly-simple-payment-field-container"></div>;
};

export { ReadonlySimplePaymentField };
